import { render, staticRenderFns } from "./component-footer-menu.vue?vue&type=template&id=14a8945c"
import script from "./component-footer-menu.vue?vue&type=script&lang=js"
export * from "./component-footer-menu.vue?vue&type=script&lang=js"
import style0 from "./component-footer-menu.vue?vue&type=style&index=0&id=14a8945c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports